import SuccessIcon from '../components/common/icons/color/ic__exito.svg';
import ErrorIcon from '../components/common/icons/color/ic__error.svg';
import InfoIcon from '../components/common/icons/color/ic__informacion.svg';
import AlertIcon from '../components/common/icons/color/ic__alerta-120.svg';

export const iconSeverityPicker = (severity) => {
  switch (severity) {
    case 'success':
      return SuccessIcon;
    case 'error':
      return ErrorIcon;
    case 'info':
      return InfoIcon;
    default:
      return AlertIcon;
  }
};
